import { SwalMessage, isValidPhoneNumber } from '../Tools';

var Checkout = (function () {
    let form;

    let authType; // oturum durumu; misafir veya müşteri

    let isCheckAddress = false;

    let paymentMethodSelection; // seçili ödeme türü

    // misafir adres storage
    const localStorageAddressInvoicesName = 'address_invoices';
    let localStorageAddressInvoices = localStorage.getItem(localStorageAddressInvoicesName)
        ? JSON.parse(localStorage.getItem(localStorageAddressInvoicesName))
        : [];

    const localStorageAddressShippingsName = 'address_shippings';
    let localStorageAddressShippings = localStorage.getItem(localStorageAddressShippingsName)
        ? JSON.parse(localStorage.getItem(localStorageAddressShippingsName))
        : [];

    // Misafir adresleri aktarma
    var guestAddressHandle = function () {
        if (localStorageAddressInvoices) {
            localStorageAddressInvoices.forEach(function (address) {
                var option = document.createElement('option');
                option.text = address[0].invoice_name.invoice_name;
                option.setAttribute('data-address', JSON.stringify(address));
                form.querySelector('[data-form-select="invoice"]').add(option);
            });
        }

        if (localStorageAddressShippings) {
            localStorageAddressShippings.forEach(function (address) {
                //console.log(address);
                var option = document.createElement('option');
                option.text = address[0].shipping_name.shipping_name;
                option.setAttribute('data-address', JSON.stringify(address));
                form.querySelector('[data-form-select="shipping"]').add(option);
            });
        }
    };

    // adres işlemleri
    var addressHandle = function () {
        // option adres ekleme - dizilerde problem var gibi kontrol edilecek
        let addAddress = function (formAjax, type) {
            let formData = $(formAjax).serializeArray();
            let replaceData = [];
            let optionName;
            formData.forEach(function (value) {
                if (value.name == 'shipping_name' || value.name == 'invoice_name') {
                    optionName = value.value;
                }
                if (value.name != 'user_id') {
                    let data = {};
                    data[value.name] = {};
                    data[value.name][value.name] = value.value;
                    replaceData.push(data);
                }
            });
            const obj = replaceData;
            //console.log(obj);

            var option = document.createElement('option');
            option.text = optionName;
            option.setAttribute('data-address', JSON.stringify(obj));
            form.querySelector('[data-form-select="' + type + '"]').add(option);

            if (type == 'invoice') {
                localStorageAddressInvoices.push(replaceData);
                localStorage.setItem(localStorageAddressInvoicesName, JSON.stringify(localStorageAddressInvoices));
            } else if (type == 'shipping') {
                localStorageAddressShippings.push(replaceData);
                localStorage.setItem(localStorageAddressShippingsName, JSON.stringify(localStorageAddressShippings));
            }

            $('[data-form-select="' + type + '"] option:last-child').attr('selected', 'selected');

            selectedAddressInfo();

            // form.querySelector('[data-form-select="' + type + '"]')?.trigger('change');
        };

        // teslimat adresi kaydetme
        $(form).on('click', '[data-canvas-save="shipping"]', function (event) {
            event.preventDefault();

            const shippingForm = document.querySelector('[data-form="shipping"]');
            let button = this;

            // telefon düzenleme
            var values = $(shippingForm).serializeArray();

            $.ajax({
                url: apiUrl + '/UserShippingAddress',
                type: 'POST',
                dataType: 'json',
                data: values,
                async: true,
                error: function error(xhr) {
                    //console.log(xhr)
                    if (xhr.responseJSON?.row?.type == 'guest') {
                        addAddress(shippingForm, 'shipping');
                        $('#canvasShippings [data-bs-dismiss="offcanvas"]').click();
                        return;
                    }

                    $(shippingForm).find('.invalid-feedback').empty();
                    $(shippingForm).find('*').removeClass('is-invalid');
                    $.each(xhr.responseJSON.errors, function (name, message) {
                        let element = shippingForm.querySelector('[name="' + name + '"]');

                        element.classList.add('is-invalid');

                        let valid = element.closest('div').querySelector('.invalid-feedback');
                        if (valid) {
                            valid.style.display = 'block';
                            valid.innerHTML = message;
                        }
                    });
                },
                beforeSend: function () {
                    button.setAttribute('disabled', '');
                },
                complete: function () {
                    button.removeAttribute('disabled');
                },
                success: function success(xhr) {
                    if (authType && authType.value == 'guest') {
                        addAddress(shippingForm, 'shipping');
                        $('#canvasShippings [data-bs-dismiss="offcanvas"]').click();
                    } else {
                        SwalMessage(
                            {
                                type: 'success',
                                text: xhr.text ?? xhr.message,
                                confirmButton: translate.ok_button
                            },
                            function () {
                                location.reload();
                            }
                        );
                    }
                }
            });
        });
        // teslimat adresi kaydetme iptal
        $(form).on('click', '[data-canvas-close="shipping"]', function (event) {
            event.preventDefault();
            $('#canvasShippings [data-bs-dismiss="offcanvas"]').click();
        });

        // fatura adresi kaydetme
        $(form).on('click', '[data-canvas-save="invoice"]', function (event) {
            event.preventDefault();

            const invoiceForm = event.target.closest('[data-form="invoice"]');
            let button = this;

            // telefon düzenleme
            var values = $(invoiceForm).serializeArray();

            $.ajax({
                url: apiUrl + '/UserInvoiceAddress',
                type: 'POST',
                dataType: 'json',
                data: values,
                async: true,
                error: function error(xhr) {
                    //console.log(xhr)
                    if (xhr.responseJSON?.row?.type == 'guest') {
                        addAddress(invoiceForm, 'invoice');
                        $('#canvasInvoices [data-bs-dismiss="offcanvas"]').click();
                        return;
                    }

                    $(invoiceForm).find('.invalid-feedback').empty();
                    $(invoiceForm).find('*').removeClass('is-invalid');
                    $.each(xhr.responseJSON.errors, function (name, message) {
                        let element = invoiceForm.querySelector('[name="' + name + '"]');

                        element.classList.add('is-invalid');

                        let valid = element.closest('div').querySelector('.invalid-feedback');
                        if (valid) {
                            valid.style.display = 'block';
                            valid.innerHTML = message;
                        }
                    });
                },
                beforeSend: function () {
                    button.setAttribute('disabled', '');
                },
                complete: function () {
                    button.removeAttribute('disabled');
                },
                success: function success(xhr) {
                    if (authType && authType.value == 'guest') {
                        addAddress(invoiceForm, 'invoice');
                        $('#canvasInvoices [data-bs-dismiss="offcanvas"]').click();
                    } else {
                        SwalMessage(
                            {
                                type: 'success',
                                text: xhr.text ?? xhr.message,
                                confirmButton: translate.ok_button
                            },
                            function () {
                                location.reload();
                            }
                        );
                    }
                }
            });
        });
        // fatura adresi kaydetme iptal
        $(form).on('click', '[data-canvas-close="invoice"]', function (event) {
            event.preventDefault();
            $('#canvasInvoices [data-bs-dismiss="offcanvas"]').click();
        });
    };

    // Fatura adresim Teslimat adresim ile aynı kontrolü
    var checkAddress = function () {
        var shippingAddress = form.querySelector('[data-address-type="shipping"]');
        var invoiceAddress = form.querySelector('[data-address-type="invoice"]');

        var checkAddressCheckbox = form.querySelector("input[name='checkAddress']");

        if (!checkAddressCheckbox) {
            return;
        }

        checkAddressCheckbox.addEventListener('change', function () {
            isCheckAddress = this.checked;

            if (this.checked) {
                // console.log("Checkbox seçildi.");
                invoiceAddress?.classList.add('d-none');
            } else {
                // console.log("Checkbox seçimi kaldırıldı.");
                invoiceAddress?.classList.remove('d-none');
            }
        });

        if (checkAddressCheckbox.checked) {
            invoiceAddress?.classList.add('d-none');
        } else {
            invoiceAddress?.classList.remove('d-none');
        }
    };

    // sipariş oluşturma
    var orderHandle = function () {
        const shippingElement = form.querySelector('[data-form-select="shipping"]');
        const invoiceElement = form.querySelector('[data-form-select="invoice"]');

        // session id oluşturma
        const localSessionName = 'session_id';
        let localSessionId = localStorage.getItem(localSessionName) ? localStorage.getItem(localSessionName) : null;

        var checkAddressCheckbox = form.querySelector("input[name='checkAddress']");
        if (checkAddressCheckbox) {
            isCheckAddress = checkAddressCheckbox?.checked;
        }

        var ajaxInit = function (button, url) {
            let shippingAddres = shippingElement.options[shippingElement.selectedIndex].getAttribute('data-address');
            let invoiceAddress = invoiceElement?.options[invoiceElement?.selectedIndex]?.getAttribute('data-address');

            const shippingMethod = document.querySelector('input[name="shipping_id"]:checked');
            const paymentMethod = document.querySelector('input[name="payment_id"]:checked');

            let couponId = null;
            if (document.querySelector('[name="coupon_id"]')) {
                couponId = document.querySelector('[name="coupon_id"]').value;
            }
            let formData = {
                user_id: form.getAttribute('data-user-id'),
                currency_id: document.querySelector('[data-currency-default]').getAttribute('data-currency-id'),
                isCheckAddress: isCheckAddress,
                session_id: localSessionId,
                terms: form.querySelector('#terms').checked,
                shipping_id: shippingMethod?.value,
                payment_id: paymentMethod?.value,
                description: form.querySelector('[name="description"]').value,
                discount_total: form.querySelector('[data-element-coupontotal]').innerText,
                grand_total: form.querySelector('[data-element-grandtotal]').innerText,
                payment_content: ''
            };

            // kupon kodu varsa
            if (document.querySelector('[name="coupon_id"]')) {
                let couponCode = document.querySelector('[name="coupon_code"]').value;
                if (couponCode) {
                    // formData.payment_content = couponCode + ' ile alışveriş yapıldı.';
                    formData.coupon_id = couponId;
                }
            }

            if (isCheckAddress) {
                formData.address = {
                    shipping: JSON.parse(shippingAddres),
                    invoice: JSON.parse(shippingAddres)
                };
            } else {
                formData.address = {
                    shipping: JSON.parse(shippingAddres),
                    invoice: JSON.parse(invoiceAddress)
                };
            }

            // misafir müşteri bilgileri
            if (authType && authType.value == 'guest') {
                formData.name = document.querySelector('#guest-form [name="name"]').value;
                formData.email = document.querySelector('#guest-form [name="email"]').value;
                formData.phone = document.querySelector('#guest-form [name="phone"]').value;
            }

            // havale seçimi
            if (paymentMethodSelection == 'havale') {
                let bankSelect = form.querySelector('[data-form-select="bank-accounts"]');
                formData.payment_content = bankSelect.options[bankSelect.selectedIndex].text;
            }

            const paymentModal = document.getElementById('paymentModal');

            $.ajax({
                url: apiUrl + '/' + url,
                type: 'POST',
                dataType: 'json',
                data: formData,
                async: true,
                error: function error(xhr) {
                    //console.log(xhr)
                    SwalMessage(
                        {
                            type: 'error',
                            text: xhr.responseJSON.text ?? xhr.responseJSON.message,
                            confirmButton: translate.ok_button
                        },
                        function () {
                            // location.reload();
                        }
                    );
                },
                beforeSend: function () {
                    button.setAttribute('disabled', '');
                },
                complete: function () {
                    button.removeAttribute('disabled');
                },
                success: function success(xhr) {
                    //console.log(xhr)

                    // Ödeme penceresi
                    const modalPaymentContent = paymentModal.querySelector('.modal-body');

                    // Başarısız işlem
                    if (xhr.code === 500) {
                        SwalMessage(
                            {
                                type: 'error',
                                text: xhr.text ?? xhr.message,
                                confirmButton: translate.ok_button
                            },
                            function () {}
                        );
                    }
                    // Ödeme türüne göre işlem
                    else if (xhr.code === 200 && xhr.row.payment.code === 200 && xhr.row.payment.row?.status) {
                        // Ödeme ekranı için istek gönderme
                        $.ajax({
                            url: apiUrl + '/PaymentScreen',
                            type: 'POST',
                            dataType: 'html',
                            data: {
                                orderNumber: xhr.row.order_number,
                                data: xhr.row.payment.row.data
                            },
                            async: false,
                            error: function error(xhr) {
                                console.log(xhr);

                                let responseText = xhr.responseJSON?.text || xhr.responseJSON?.message;

                                if (!responseText) {
                                    try {
                                        const responseObj = JSON.parse(xhr.responseText); // JSON formatını manuel kontrol
                                        responseText = responseObj.text || responseObj.message;
                                    } catch (e) {
                                        console.error('Yanıt JSON formatında değil:', e);
                                        responseText = 'Bilinmeyen bir hata oluştu';
                                    }
                                }

                                SwalMessage(
                                    {
                                        type: 'error',
                                        text: responseText,
                                        confirmButton: translate.ok_button
                                    },
                                    function () {
                                        // location.reload();
                                    }
                                );
                            },
                            success: function success(xhr) {
                                modalPaymentContent.innerHTML = xhr;
                                $(paymentModal).modal('show');
                            }
                        });
                    }
                    // Başarılı işlem ve yönlendirilen sayfa
                    else if (xhr.redirectUrl && xhr.code === 200) {
                        SwalMessage(
                            {
                                type: 'success',
                                text: xhr.text ?? xhr.message,
                                confirmButton: translate.ok_button
                            },
                            function () {
                                location.href = xhr.redirectUrl;
                            }
                        );
                    }
                    // Koşulsuz veya Başarısız işlem
                    else {
                        SwalMessage(
                            {
                                type: 'info',
                                text: xhr.text ?? xhr.message,
                                confirmButton: translate.ok_button
                            },
                            function () {}
                        );
                    }

                    return;
                }
            });
        };

        $(form).on('click', '[data-form-submit]', function (event) {
            event.preventDefault();

            if (authType && authType.value == 'guest') {
                ajaxInit(this, 'GuestOrderCreate');
            } else {
                ajaxInit(this, 'OrderCreate');
            }
        });
    };

    var handle = function () {
        // misafir adreslerini localstorage'den aktarma
        if (authType && authType.value == 'guest') {
            guestAddressHandle();
        }

        // data-form-select="shipping" ve data-form-select="invoice" change işleminde adres bilgilerini getirme
        $(form).on('change', '[data-form-select="shipping"], [data-form-select="invoice"]', function (event) {
            event.preventDefault();

            selectedAddressInfo();
        });
    };

    // oturum işlemleri
    var authSelection = function () {
        const guestForm = form.querySelector('#guest-form');

        $(form).on('click', '[data-guest-select]', function (event) {
            guestForm.classList.remove('d-none');
        });
        $(form).on('click', '[data-auth-select]', function (event) {
            guestForm.classList.add('d-none');
        });

        // oturum aç
        $(form).on('click', '[data-login-submit]', function (event) {
            event.preventDefault();

            let loginForm = event.target.closest('form');
            let button = this;

            $.ajax({
                url: $(loginForm).attr('action'),
                type: 'POST',
                dataType: 'json',
                data: $(loginForm).serialize(),
                async: true,
                error: function error(xhr) {
                    //console.log(xhr)
                    $(loginForm).find('.invalid-feedback').empty();
                    $(loginForm).find('*').removeClass('is-invalid');
                    $.each(xhr.responseJSON.errors, function (name, message) {
                        let element = loginForm.querySelector('[name="' + name + '"]');

                        element.classList.add('is-invalid');

                        let valid = element.closest('div').querySelector('.invalid-feedback');
                        if (valid) {
                            valid.style.display = 'block';
                            valid.innerHTML = message;
                        }
                    });
                },
                beforeSend: function () {
                    button.setAttribute('disabled', '');
                },
                complete: function () {
                    button.removeAttribute('disabled');
                },
                success: function success(xhr) {
                    if (xhr.two_factor) {
                        window.location.href = '/two-factor-challenge';
                    } else {
                        location.reload();
                    }
                }
            });
        });
    };

    // ödeme metodu seçimi
    var paymentMethodHandle = function () {
        let selectDiv = form.querySelector('.bank-account-list');
        if (!selectDiv) {
            return;
        }
        let selectElement = selectDiv.querySelector('[data-form-select="bank-accounts"]');

        $(form).on('change', '#paymentMethodSelection .form-check-input', function (event) {
            event.preventDefault();

            const radioButtons = document.querySelectorAll('#paymentMethodSelection .form-check-input');

            for (const radioButton of radioButtons) {
                if (radioButton.checked) {
                    paymentMethodSelection = radioButton.getAttribute('data-method');
                    if (paymentMethodSelection == 'paytr') {
                        selectDiv.classList.add('d-none');
                        selectElement.innerHTML = '';
                    }
                    break;
                }
            }
        });

        // burada havele seçildiğinde banka hesapları listelenecek
        $(form).on('change', '[data-method="havale"]', function (event) {
            event.preventDefault();

            $.ajax({
                url: apiUrl + '/GetBankAccounts',
                type: 'POST',
                dataType: 'json',
                async: false,
                error: function error(xhr) {
                    //console.log(xhr)
                },
                beforeSend: function () {
                    selectDiv.classList.add('d-none');
                    selectElement.innerHTML = '';
                },
                complete: function () {
                    selectDiv.classList.remove('d-none');
                },
                success: function success(xhr) {
                    // console.log(xhr)

                    let accounts = xhr;
                    if (accounts) {
                        accounts.forEach(function (account) {
                            var option = document.createElement('option');
                            option.text = account.bank_name;
                            option.setAttribute('value', account.id);
                            if (account.default) {
                                option.setAttribute('selected', '');
                            }
                            selectElement.add(option);
                        });
                    }
                }
            });
        });
    };

    // kargo metodu seçimi
    var shippingMethodHandle = function () {
        $(form).on('change', '#shippingMethodSelection [name="shipping_id"]', function (event) {
            event.preventDefault();

            let target = event.target;
            let value = target.value;

            // console.log(value);

            $.ajax({
                url: apiUrl + '/GetShippingById',
                type: 'POST',
                dataType: 'json',
                async: true,
                data: {
                    id: value
                },
                error: function error(xhr) {
                    //console.log(xhr)
                    SwalMessage(
                        {
                            type: 'error',
                            text: xhr.responseJSON.text ?? xhr.responseJSON.message,
                            confirmButton: translate.ok_button
                        },
                        function () {
                            // location.reload();
                        }
                    );
                },
                beforeSend: function () {},
                complete: function () {},
                success: function success(xhr) {
                    // console.log(xhr)

                    let row = xhr.row;
                    if (row.amount) {
                        let amount = currencyFormat.from(row.amount);
                        let amountValue = !amount || amount < 0 ? 0 : amount;

                        let cargoElement = document.querySelector('[data-element-cargo]');
                        if (cargoElement) {
                            cargoElement.setAttribute('data-value', row.amount);
                            cargoElement.innerText = currencyFormat.to(amountValue);
                        }

                        let cargoNameElement = document.querySelector('[data-element-cargo-name]');
                        if (cargoNameElement) {
                            cargoNameElement.innerText = row.name;
                        }

                        // shippingAddressCargoFee();
                    }
                }
            });
        });
    };

    // seçili adres bilgilerini gösterme
    var selectedAddressInfo = function () {
        let shippingElement = document.querySelector('[data-form-select="shipping"]');
        let invoiceElement = document.querySelector('[data-form-select="invoice"]');

        if (!shippingElement || !invoiceElement) {
            return;
        }

        let shippingAddress = shippingElement?.options[shippingElement.selectedIndex].getAttribute('data-address');
        let invoiceAddress = invoiceElement?.options[invoiceElement.selectedIndex].getAttribute('data-address');

        // console.log(invoiceAddress);

        if (shippingAddress) {
            shippingAddress = JSON.parse(shippingAddress);

            // console.log(shippingAddress);

            try {
                shippingAddress = shippingAddress.reduce((acc, item) => {
                    const key = Object.keys(item)[0];
                    acc[key] = item[key];
                    return acc;
                }, {});
            } catch (error) {}

            if (shippingAddress.length == 0) {
                document.querySelector('[data-address-shipping-info]').innerHTML = '';
                return;
            }

            let shippingInfo = `<div class="col-md-3">
                                ${shippingAddress?.shipping_fullname?.shipping_fullname || ''}
                            </div>
                            <div class="col-md-3">
                                ${shippingAddress?.shipping_phone?.shipping_phone || ''}
                            </div>
                            <div class="col-md-3">
                                ${shippingAddress?.shipping_email?.shipping_email || ''}
                            </div>
                            <div class="col-md-12">
                                ${shippingAddress?.shipping_address?.shipping_address || ''} ${shippingAddress?.shipping_district?.shipping_district || ''}/${shippingAddress?.shipping_city?.shipping_city || ''}
                            </div>`;
            document.querySelector('[data-address-shipping-info]').innerHTML = shippingInfo;
        } else {
            document.querySelector('[data-address-shipping-info]').innerHTML = '';
        }

        if (invoiceAddress) {
            invoiceAddress = JSON.parse(invoiceAddress);

            // console.log(invoiceAddress);

            try {
                invoiceAddress = invoiceAddress.reduce((acc, item) => {
                    const key = Object.keys(item)[0];
                    acc[key] = item[key];
                    return acc;
                }, {});
            } catch (error) {}

            if (invoiceAddress.length == 0) {
                document.querySelector('[data-address-invoice-info]').innerHTML = '';
                return;
            }

            let invoiceInfo = `<div class="col-md-3">
                                ${invoiceAddress?.invoice_fullname?.invoice_fullname || ''}
                            </div>
                            <div class="col-md-3">
                                ${invoiceAddress.invoice_phone?.invoice_phone || ''}
                            </div>
                            <div class="col-md-3">
                                ${invoiceAddress?.invoice_email?.invoice_email || ''}
                            </div>
                            <div class="col-md-12">
                                ${invoiceAddress?.invoice_address?.invoice_address || ''} ${invoiceAddress?.invoice_district?.invoice_district || ''}/${invoiceAddress?.invoice_city?.invoice_city || ''}
                            </div>`;

            document.querySelector('[data-address-invoice-info]').innerHTML = invoiceInfo;
        } else {
            document.querySelector('[data-address-invoice-info]').innerHTML = '';
        }
    };

    return {
        init: function () {
            form = document.querySelector('.page-shopping-cart');
            if (!form) {
                return;
            }
            authType = form.querySelector('[name="auth-type"]');

            handle();
            authSelection();
            addressHandle();
            paymentMethodHandle();
            shippingMethodHandle();
            orderHandle();
            checkAddress();
            selectedAddressInfo();
        }
    };
})();

$(function () {
    Checkout.init();
});
